import GridShape from '../../components/common/GridShape'
import { Link } from 'react-router'
import PageMeta from '../../components/common/PageMeta'

export default function NotFound() {
  return (
    <>
      <PageMeta
        title="Página não encontrada | MDi Optimus"
        description="O endereço aberto não existe no Optimus."
      />
      <div className="relative flex flex-col items-center justify-center min-h-screen p-6 overflow-hidden z-1">
        <GridShape />
        <div className="mx-auto w-full max-w-[242px] text-center sm:max-w-[472px]">
          <h1 className="mb-8 font-bold text-gray-800 text-title-md dark:text-white/90 xl:text-title-2xl">
            Página não encontrada
          </h1>

          <img src="/images/error/404.svg" alt="" className="dark:hidden" />
          <img
            src="/images/error/404-dark.svg"
            alt=""
            className="hidden dark:block"
          />

          <p className="mt-10 mb-6 text-base text-gray-700 dark:text-gray-400 sm:text-lg">
            Este endereço não existe no Optimus. Ele pode ter mudado, ou o link
            veio incompleto.
          </p>

          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-5 py-3.5 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200"
          >
            Voltar ao início
          </Link>
        </div>
        {/* <!-- Footer --> */}
        <p className="absolute text-sm text-center text-gray-500 -translate-x-1/2 bottom-6 left-1/2 dark:text-gray-400">
          &copy; {new Date().getFullYear()} - MDi Optimus
        </p>
      </div>
    </>
  )
}
